export default __webpack_public_path__ + "static/media/tip5.52f05fb4.png";